import classNames from 'classnames';
import * as bd from 'react-basic-design';
import { translate } from './text';
export const CellChip = ({
    label,
    disabled = false,
    color = 'default',
}: {
    label: string;
    disabled?: boolean;
    color?: 'red' | 'info' | 'success' | 'default';
}) => {
    return (
        <bd.Button
            variant="icon"
            pill
            size="sm"
            disabled={disabled}
            color="inherit"
            className={classNames('d-sm-block px-2 py-1', {
                'border bg-gray-5': color === 'default',
                'border border-danger bg-danger text-danger': color === 'red',
                'border border-info bg-info text-info': color === 'info',
                'border border-success bg-success text-success': color === 'success',
            })}
            disableRipple
            edge="end"
        >
            <span className="small">{translate(label)}</span>
        </bd.Button>
    );
};
